import request from '@/libs/request'

export function List (data) {
  return request({
    url: `shop/list`,
    method: 'get',
    params: data
  })
}
export function listAll (data) {
  return request({
    url: `shop/listAll`,
    method: 'get',
    params: data
  })
}

// 详情
export function Info (data) {
  return request({
    url: `shop/info`,
    method: 'get',
    params: data
  })
}
// 详情
export function getLan (data) {
  return request({
    url: `shop/getLan`,
    method: 'get',
    params: data
  })
}
// 添加
export function edit(data) {
  return request({
    url: `shop/setEdit`,
    method: 'post',
    data: data
  })
}

// 删除公告
export function dels (id) {
  let data = { id: id }
  return request({
    url: `shop/del`,
    method: 'post',
    data: data
  })
}

// 添加
export function lanEdit(data) {
  return request({
    url: `shop/lanEdit`,
    method: 'post',
    data: data
  })
}

